<script>
  import appConfig from "@/app.config";
  import PageHeader from "@/components/page-header";
  import Layout from "@/router/layouts/main";
  
  /**
   * Starter component
   */
  export default {
    page: {
      title: "Kontak Kami",
      meta: [{ name: "description", content: appConfig.description }],
    },
    components: {
      Layout,
      PageHeader,
    },
    data() {
      return {
        phaseOneShow: false,
      };
    },
  
    computed: {
      title() {
        return this.$t("menuitems.contactUs.text");
      },
    },
  };
  </script>
  
  <template>
    <Layout>
      <PageHeader :title="title" />
      <p class="mb-4">Semua kontak dan alamat McEasy ada disini.</p>
  
      <div class="mc-contact">
        <h4 class="mc-contact__title">
          <strong>Hubungi Kami</strong>
        </h4>
        <b-row class="mb-4">
          <b-col md="6" class="mb-2">
            <h5>
              <i class="mc-fa icon-fill_pin"></i>
              Head Office
            </h5>
            <p>Sinarmas Land Plaza Lt. 8 Unit 801-803 Jl.Pemuda No. 60-70 Surabaya, 60271 - Jawa Timur</p>
          </b-col>
          <b-col md="6" class="mb-2">
            <h5>
              <i class="mc-fa icon-fill_pin"></i>
              Operational Office
            </h5>
            <p>Jl. Cikini Raya No. 71 Kec. Menteng, Jakarta Pusat, 10330 - DKI Jakarta, Indonesia</p>
          </b-col>
          <b-col md="6" class="mb-2">
            <h5>
              <i class="mc-fa icon-fill_phone"></i>
              Telepon Head Office
            </h5>
            <p>(031) 9925 - 3933</p>
          </b-col>
          <b-col md="6" class="mb-2">
            <h5>
              <i class="mc-fa icon-outline_smartphone"></i>
              Mobile
            </h5>
            <p>0819 - 9320 - 9999</p>
          </b-col>
          <b-col md="6" class="mb-2">
            <h5>
              <i class="mc-fa icon-outline_smartphone"></i>
              Mobile
            </h5>
            <p>0811 - 3166 - 89</p>
          </b-col>
        </b-row>
        <h4 class="mc-contact__title">
          <strong>Ikuti Kami di media sosial untuk informasi terbaru</strong>
        </h4>
        <div class="mc-contact__sosmed mb-5">
          <a href="https://www.facebook.com/mceasy.id/" target="_blank">
            <img src="@/assets/images/sosmed/fb.svg" alt />
          </a>
          <a href="https://www.instagram.com/mceasy.id/" target="_blank">
            <img src="@/assets/images/sosmed/ig.svg" alt />
          </a>
          <a href="https://www.linkedin.com/company/mceasy/" target="_blank">
            <img src="@/assets/images/sosmed/ln.svg" alt />
          </a>
          <a href="https://www.youtube.com/channel/UCiRbvBZkNgR5Pf8x5lcqWNw" target="_blank">
            <img src="@/assets/images/sosmed/yt.svg" alt />
          </a>
          <a href="https://bit.ly/mceasy-wa-business" target="_blank">
            <img src="@/assets/images/sosmed/wa.svg" alt />
          </a>
        </div>
      </div>
    </Layout>
  </template>